import React from "react";
import styled from "styled-components/macro";
import { PopUpItem } from "./PopUpItem";
import { Popup } from "semantic-ui-react";

const RideUnit = ({
  ride,
  onPopupOpen,
  onPopupClose,
  showDimensions,
  itemsCount,
}) => {
  const _renderRideItems = () => {
    return ride.map((item) => {
      return (
        <Popup
          position="right center"
          on="click"
          onOpen={onPopupOpen}
          onClose={onPopupClose}
          trigger={<Img src={item.unitImage} height={332} />}
          flowing
        >
          <PopUpItem item={item} quantity={itemsCount[item.id]} />
        </Popup>
      );
    });
  };

  return (
    <Wrapper>
      {_renderRideItems()}
      <WrapperUnit>
        <MiddleBorder />
      </WrapperUnit>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  transform: scale(0.9);
  position: fixed;
  align-self: flex-end;
`;
const WrapperUnit = styled.div`
  //background-image: linear-gradient(to bottom, #464545, #484848 11%, #0f0f0f);
  border-top: 40px #464545 solid;
  border-left: 10px #464545 solid;
  border-right: 10px #464545 solid;
  padding: 0 20px;
  height: 100%;
  border-radius: 30px 30px 0 0;
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

const Img = styled.img`
  object-fit: contain;
  z-index: 9999;
  position: relative;
  cursor: pointer;
  padding-top: 10px;
`;

const MiddleBorder = styled.div`
  position: absolute;
  top: 93px;
  left: 0;
  right: 0;
  bottom: -1px;
  background-color: transparent;
  z-index: 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-top: 8px #464545 solid;
  border-bottom: 8px transparent solid;
`;
export { RideUnit };
